// extracted by mini-css-extract-plugin
export default {"pantalla":"MeetingFrameLeft_pantalla__+rbAT ui_pantallaReunion__POLfo"};